import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { T, t } from '@sm/intl';
import { Toast } from '@wds/toast';
import { IconWarningFilled } from '@wds/icons';
export const COPY = {
  errorTitle: {
    id: 'OpenEndedCoding.ExportToastError.ErrorTitle',
    defaultMessage: 'Error fetching export.',
    description: '[Type: Label][Vis.: high] - Appears in the bottom of the browser as the title of export error prompt'
  },
  errorBody: {
    id: 'OpenEndedCoding.ExportToastError.ErrorBody',
    defaultMessage: 'Please try refreshing the page or contact customer support.',
    description: '[Type: Label][Vis.: high] - Appears in the bottom of the browser as the body of export error prompt'
  },
  iconError: {
    id: 'OpenEndedCoding.ExportToastError.IconError',
    defaultMessage: 'Error icon',
    description: '[Type: Label][Vis: low] - error icon'
  }
};
const ToastError = () => {
  return _jsxs(Toast, {
    dismissible: true,
    autoClose: false,
    children: [_jsxs(Toast.Title, {
      children: [_jsxs("span", {
        children: [_jsx(IconWarningFilled, {
          color: "error",
          size: "md",
          title: t(COPY.iconError)
        }), "\u00A0"]
      }), _jsx(T, {
        desc: COPY.errorTitle
      })]
    }), _jsx(Toast.Body, {
      children: _jsx(T, {
        desc: COPY.errorBody
      })
    })]
  });
};
export default ToastError;